module.exports = __webpack_public_path__ + "img/image-mt-8.363a9a05.png";